import type { IconData } from '@stacksjs/iconify-core'

export const beautyCosmaticLipStick: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.185 24.38h-9.14v-1.52h-1.52V32h12.19v-9.14h-1.53zm-4.57-19.81h3.05V6.1h-3.05Zm0 6.1h1.53v3.05h-1.53Zm-1.52-4.57h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M28.185 22.86V6.1h-1.52v10.67h-6.1V9.15h-1.52v13.71Zm-7.62-4.57h6.1v3.05h-6.1Z\"/><path fill=\"currentColor\" d=\"M20.565 7.62h1.53v1.53h-1.53ZM3.805 0v1.53h-1.52V32h12.19V1.53h-1.52V0Zm9.15 24.38h-9.15v-1.52h9.15Zm0-3.04h-9.15v-3.05h9.15Zm0-12.19h-1.53V4.57h-3.05V3.05h3.05v1.52h1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default beautyCosmaticLipStick
